import { executeRequest, Request } from '@jfs/network'
import { convertDateInto } from '../../utils'
import { getAPIURL, getPaymentHeader } from '../config'

export const HEIGHT_QR_CODE = 250
export const WIDTH_QR_CODE = 250

//"expireAfter": "2024-09-10T16:25:31+0530" currentTime plus 3 minues
const generateQrCodeRequest = (mid: string, amount: string, intentId: string, type: string = 'URI', mobile: number) => {
  const currentTime = new Date(Date.now())
  const expiryTime = new Date(currentTime.getTime() + 60000 * 3)
  const formatedTime = convertDateInto(expiryTime)
  let req: any = {
    data: {
      merchantId: mid,
      type: 'DYNAMIC',
      qrInterfaceType: 'UPI',
      amount: amount,
      intentId: intentId,
      medium: 'INTENT',
      expireAfter: formatedTime,
      qrInterface: {
        height: HEIGHT_QR_CODE,
        width: WIDTH_QR_CODE,
      },
      paymentAcceptance: ['526'],
    },
    config: {
      outputType: type,
    },
  }
  const mobileStr = '' + mobile
  if (mobileStr.length === 10) {
    req.data.notification.sms = [`+91${mobile}`]
  }
  return req
}

const generateQr = (req: any) => {
  const URL = getAPIURL('upiIntent')
  const request: Request<{}> = {
    apiPath: URL,
    method: 'POST',
    headers: getPaymentHeader(),
    body: req,
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return data.data
    } else {
      throw data
    }
  })
}

export { generateQrCodeRequest, generateQr }
